import { Component, DestroyRef, inject } from '@angular/core';

import { CanvasConfettiService } from '@core/common-legacy';
import { I18nService } from '@core/i18n-legacy';
import { OfferStatus } from '@core/offers-types';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogRef,
  HeadingComponent,
} from '@core/user-interface-legacy';

type FirstJobPublishedDialogData = {
  status: OfferStatus.Internal | OfferStatus.Published;
};

@Component({
  selector: 'rt-first-job-published-dialog',
  imports: [DialogBodyComponent, HeadingComponent, ButtonComponent],
  templateUrl: './first-job-published-dialog.component.html',
  styleUrl: './first-job-published-dialog.component.less',
})
export class FirstJobPublishedDialogComponent
  implements DialogComponentI<FirstJobPublishedDialogData, boolean>
{
  private readonly i18n = inject(I18nService);
  private readonly dialogRef = inject(DialogRef);
  private readonly canvasConfettiService = inject(CanvasConfettiService);
  private readonly destroyRef = inject(DestroyRef);

  public readonly translations = {
    heading: this.i18n.translate('app.offers.first_job_published_dialog.heading'),
    description: this.i18n.translate('app.offers.first_job_published_dialog.description'),
    cancel: this.i18n.translate('app.common.cancel'),
    promoteJob: this.i18n.translate('app.offers.first_job_published_dialog.promote_job'),
    viewJobsPipeline: this.i18n.translate(
      'app.offers.first_job_published_dialog.view_jobs_pipeline',
    ),
  };
  public readonly imageSrc = 'assets/images/offers/first-job-published.svg';

  public status: OfferStatus.Internal | OfferStatus.Published;

  private stopConfetti: () => void;
  private unregisterDestroy = this.destroyRef.onDestroy(() => this.stopConfetti());

  public get isInternalJob(): boolean {
    return this.status === OfferStatus.Internal;
  }

  public ngOnInit(): void {
    this.stopConfetti = this.canvasConfettiService.fireworks();
  }

  public setDialogData(data: FirstJobPublishedDialogData): void {
    this.status = data.status;
  }

  public close(): void {
    this.dialogRef.close(false);
  }

  public onCtaButtonClick(): void {
    this.dialogRef.close(true);
  }
}
